// src/com/sms_message/SmsMessageList.js
import React, { useEffect, useRef, useState } from 'react';
import styled from '@emotion/styled';
import { Box } from '@mui/system';
import { Button, TextField } from '@mui/material';
import FlexyTable from '../common/flexytable/FlexyTable';
import ValueUtil from '../../model/ValueUtil';
import { AppObject, AppWord } from '../../model/AppConst';
import { LIST_SMS_MESSAGE, SmsMessageTableColumns } from './SmsMessageGql';
import { useLazyQuery, useReactiveVar } from '@apollo/client';
import ResponseAlert from '../message/ResponseAlert';
import { smsMessageListRepo, smsMessageReloadSignalRepo } from '../../model/CvoModel';
import { ContentHeader, HeaderLeft } from '../common/CvoStyled';
import SearchBox from '../common/SearchBox';
import { useSnackbar } from 'notistack';

const SmsListContainer = styled(Box)({
    flex:1,
    display:"flex", flexDirection:'column'
});


export default function SmsMessageList() {
    const smsMessageList = useReactiveVar(smsMessageListRepo);
    const smsMessageReloadSignal = useReactiveVar(smsMessageReloadSignalRepo);
    const [dateRange, setDateRange] = useState({dateFrom: ValueUtil.getYmdText(86400*7), dateTill: ValueUtil.getYmdText(0)});
    const [responseAlert, setResponseAlert] = useState(null);
    const [search, setSearch] = useState('');
    const { enqueueSnackbar } = useSnackbar();
    const loadedRef = useRef(0);
    
    // ##### Call GraphQL to get List #####
    const [getSmsMessageList, responseList] = useLazyQuery(LIST_SMS_MESSAGE, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data, option) => {onCompleteGetList(data, option)},
        onError: (error) => {setResponseAlert({open: true, error: error, title: 'SMS 전송기록 조회 오류'})}
    });

    useEffect(() => {
        if(smsMessageReloadSignal.count > 0 && smsMessageReloadSignal.from && smsMessageReloadSignal.till) {
            const param = {dateFrom: smsMessageReloadSignal.from, dateTill: smsMessageReloadSignal.till};
            getSmsMessageList({variables: param});
        }
    }, [smsMessageReloadSignal]);

    // >>>>>>>>> callbacks <<<<<<<<<<<<<
    const onCompleteGetList = (data, clientOption) => {
        if(data.smsMessageList) {
            loadedRef.current = (new Date()).getTime();
            // setRecords(data.smsMessageList);
            smsMessageListRepo(data.smsMessageList);
            if(data.smsMessageList.length === 0) {
                enqueueSnackbar('조회된 SMS 전송기록이 없습니다.', {autoHideDuration:1500});
            }
        }
    };

    const onChangeSearch = (text) => {
        setSearch(text);
    };

    const onChangeDate = (event) => {
        const range = {...dateRange};
        range[event.target.id] = event.target.value;
        setDateRange(range);
    };
    
    const onClickGetList = () => {
        const from = ValueUtil.parseDate(dateRange.dateFrom);
        const till = ValueUtil.parseDate(dateRange.dateTill);
        let param;
        if(from && till) {
            if(from.getTime() <= till.getTime()) param = {...dateRange};
            else param = {dateFrom: dateRange.dateTill, dateTill: dateRange.dateFrom};
            getSmsMessageList({variables: param});
            smsMessageReloadSignalRepo({count: 0, from: param.dateFrom, till: param.dateTill});
        }
    };


    return(
        <SmsListContainer>
            <ContentHeader>
                <HeaderLeft>
                    <span>조회날짜범위 &nbsp;</span>
                    <TextField id='dateFrom' type='date' value={dateRange.dateFrom} size={AppWord.SMALL} onChange={onChangeDate} />
                    ~
                    <TextField id='dateTill' type='date' value={dateRange.dateTill} size={AppWord.SMALL} onChange={onChangeDate} />
                    <Button size={AppWord.SMALL}
                        onClick={onClickGetList}
                        variant='contained' color="primary"
                        disabled={!Boolean(dateRange.dateFrom) || !Boolean(dateRange.dateTill)}
                        style={{marginLeft:10, marginRight: 10}}
                    >
                        조회
                    </Button>
                    <SearchBox onChange={onChangeSearch} value={search}/>
                </HeaderLeft>
            </ContentHeader>
            <FlexyTable
                name="sms_message_list"
                uniqueKey="smsId"
                columns={SmsMessageTableColumns}
                records={smsMessageList}
                search={search}
                tools={undefined}
            />
            <ResponseAlert open={responseAlert ? responseAlert.open : false}
                alertData={responseAlert}
                onClose={() => {setResponseAlert(null)}}/>
        </SmsListContainer>
    );
}